<template>
    <div>
        <div v-if="successMessage" class="col-md-6 alert alert-success" role="alert">
            {{ successMessage }}
        </div>

        <div class="table-responsive mt-1" style="min-height: 400px;">
            <table class="table">
                <thead>
                <tr>
                    <th>{{ translate.platform }}</th>
                    <th>{{ translate.store }}</th>
                    <th>{{ translate.version }}</th>
                    <th>{{ translate.url }}</th>
                    <th>{{ translate.date }}</th>
                </tr>
                </thead>
                <tbody>
                <app-version-table-row
                    v-for="version in sortedVersions"
                    :translate="translate.row"
                    :key="version.id"
                    :item="version"
                    @success="onRowSuccess"
                />
                </tbody>
            </table>
        </div>
    </div>

</template>

<script>
export default {
    props: ['data', 'translate'],
    data() {
        return {
            versions: this.data,
            successMessage: null
        }
    },
    computed: {
        sortedVersions: function() {
            let order = [1, 3, 2, 4];
            let orderDict =  order.reduce((acc, item, index) => {
                acc[item] = index;
                return acc;
            }, {});
            return this.versions.sort((a, b) => orderDict[a.platform_id] - orderDict[b.platform_id]);
        }
    },
    methods: {
        onRowSuccess(message) {
            this.successMessage = message;
        }
    }
}
</script>
